import { addDays } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export const getDates = (start_date: Date | null, end_date: Date | null): Date[] => end_date && start_date? Array.from({ length: (Math.ceil(((Number(end_date) - Number(start_date ) +1) / (1000 * 60 * 60 * 24)))) }, (_, i) => {
    const d = utcToZonedTime(start_date || '', 'Etc/UTC');
    return addDays(d, i);
}): [];